export default __webpack_public_path__ + "static/media/WorkSans-SemiBold.9e3cc5f1.ttf";